import { type StatItem } from "@/components/design-system/StatCard/StatCard";

export const stats: readonly StatItem[] = [
  {
    value: "$2.1 T",
    description:
      "In forgotten 401(k) assets — up 30% since 2023, across 31.9 million abandoned accounts.",
  },
  {
    value: "$67k",
    description:
      "Average balance in a forgotten 401(k). These accounts now represent nearly 25% of all 401(k) savings.",
  },
  {
    value: "$6.8 T",
    description:
      "Sitting idle in money market funds — earning sub-inflation yields while better options go unconsidered.",
  },
  {
    value: "12 x",
    description:
      "The average American changes jobs 12 times over their career — and median tenure just hit a 22-year low.",
  },
];
